export class SWF{
    patientId: string;
    patSWFId: string;
    admittedDate: number;
    surgeonName: string;
    serviceLineId: string;
    serviceLineLabel: string;
    laterality: string;
    practiceLogo: string;
    firstLogin: boolean;
}